<template>
  <section>
    <div class="fileBoxStep0">
      <div class="upload">
        <com-upload
          v-if="state == 0"
          v-model="list"
          :action="action"
          :limit="10"
          :width="312"
          :height="298"
          @add="handleAdd"
          @del="handleDel"
        />
        <el-image
          v-for="(item,index) in list"
          v-else
          :key="index"
          style="width: 312px; height: 298px"
          :src="item.url"
          :preview-src-list="[item.url]"
        />
      </div>
    </div>
  </section>
</template>

<script>
import comUpload from '@/components/comUpload'
export default {
  name: 'ComStep0',
  components: {
    comUpload
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    action: {
      type: String,
      default: ''
    },
    state: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      data2: this.data1
    }
  },
  computed: {
    list: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {},
  mounted() {},
  methods: {
    handleAdd(v) {
      this.$emit('add', v)
    },
    handleDel(v) {
      this.$emit('del', v)
    }
  }
}
</script>
<style lang="scss" scoped>
.fileBoxStep0 {
  height: 100%;
  padding: 10px 20px;
}
.fileBoxStep0 /deep/ .el-scrollbar__wrap{
  margin-bottom: 0 !important;
}
.upload{
  min-height: 629px;
}
</style>
